import $ from 'jquery';

export default {
	data: () => ({
		requestInProgress: false,
	}),
	methods: {
		abortRequest() {
			if (this.$options.xhr)
				this.$options.xhr.abort();
		},
		makeRequest(settings) {
			this.abortRequest();

			const xhr = $.ajax(settings);

			this.$options.xhr = xhr;

			this.requestInProgress = true;
			xhr.always(() => this.requestInProgress = false);

			return xhr;
		},
	},
	beforeDestroy() {
		this.abortRequest();
	}
}
